module.exports = __webpack_public_path__ + "static/media/Genset-image-SE.5a978cec.jpg";